import {Tooltip} from 'platform/components';
import {Icon} from 'platform/foundation';

import {isNil} from 'ramda';

import {CellRendererProps} from '../../types/CellRendererProps';
import {TooltipGetter} from '../../types/TooltipGetter';
import {getTooltipProps} from '../../utils/getTooltipProps';
import {EmptyCellValue} from '../EmptyCellValue/EmptyCellValue';

type CheckboxCellRendererProps = CellRendererProps<boolean | null> & {
  getTooltipProps?: TooltipGetter;
};

export function CheckboxCellRenderer(props: CheckboxCellRendererProps) {
  if (isNil(props.value)) {
    return <EmptyCellValue emptyCellValue={props.emptyCellValue} isWrap={props.isWrap} />;
  }

  const tooltipProps = getTooltipProps(props.row, props.getTooltipProps);

  return (
    <Tooltip {...tooltipProps}>
      <Icon
        value={props.value ? 'navigation/check' : 'navigation/close'}
        color={props.value ? 'severity.success' : 'severity.danger'}
        size={4}
      />
    </Tooltip>
  );
}
